import { render, staticRenderFns } from "./HomeCaGuzhu.vue?vue&type=template&id=67abe452&"
import script from "./HomeCaGuzhu.vue?vue&type=script&lang=js&"
export * from "./HomeCaGuzhu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports